module.exports = __webpack_public_path__ + "img/box_bg_1.b224ec49.png";